import { Icon } from "../ui/Icon";

export function QuestRewardList(props: {
  reward: {
    exp: number | undefined;
    sp: number | undefined;
    items: {
      icon: string;
    }[];
  };
}) {
  const countRewards = props.reward.items.length + (props.reward.exp ? 1 : 0) + (props.reward.sp ? 1 : 0);
  const sliceItems = countRewards > 12 ? 12 - props.reward.items.length - 1 : 0;
  const rewardItems = countRewards > 12 ? props.reward.items.slice(0, sliceItems) : props.reward.items;
  return (
    <div
      style={{
        width: 144,
        display: "grid",
        gridTemplateColumns: "16px 16px 16px 16px 16px 16px",
        gridGap: 8,
      }}
    >
      {props.reward.exp ? <Icon icon="etc_exp_point_i00" size={16} /> : null}
      {props.reward.sp ? <Icon icon="etc_sp_point_i00" size={16} /> : null}
      {rewardItems.map((item, i) => (
        <Icon key={i} icon={item.icon} size={16} />
      ))}
      {countRewards > 12 && <Icon icon="etc_more" size={16} />}
    </div>
  );
}
